import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Spacer, Button, Checkbox, Field, Radio } from '@cleartrip/bento'
import ModalHeader from '../UserProfileModalHeader'

import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg'
import { MOBILE_COUNTRY_CODES, POPULAR_MOBILE_COUNTRY } from 'constants/mobileCountryCodes'
import Dropdown from 'components/Dropdown'

import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'
import OtpBox from './otpBox'
import { isEmpty } from 'utils/browserHelper'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import { checkForLinkingNudge, sendOtpForSignIn } from 'api/flights/results'
import { errorConfig } from './errorConfig'

const transformEmail = email => {
    const [userName, domain] = email.split('@')
    let censoredUsername = ''
    if (userName.length > 5) {
        censoredUsername = userName[0] + userName[1] + '*'.repeat(userName.length - 4) + userName.slice(-2)
    } else {
        switch (userName.length) {
            case 1:
                censoredUsername = '*'
                break
            case 2:
                censoredUsername = userName[0] + '*'
                break
            case 3:
                censoredUsername = userName[0] + '*' + userName[2]
                break
            case 4:
                censoredUsername = userName[0] + '*'.repeat(2) + userName[3]
                break
            case 5:
                censoredUsername = userName[0] + '*'.repeat(3) + userName[4]
                break
        }
    }
    return censoredUsername + '@' + domain
}

const EmailsLinked = ({
    toggle,
    mobileNumber,
    defaultCountryCode,
    linkedEmails,
    email,
    setEmail,
    setPageName,
    showCloseButton
}) => {
    const animationDefaultState = { isAnimate: false, direction: 'right', isFadeIn: false }
    const [apiError, setApiError] = useState('')
    const [animationParams, setAnimationParams] = useState(animationDefaultState)
    const [loading, setLoading] = useState(false)
    const animatedClass = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'px-8': 'px-8'
    })

    let errorInfo = 'fs-inherit c-inherit pl-2'

    function renderEmails() {
        return linkedEmails.map(emailObj => {
            const { userName } = emailObj || {}
            return (
                <div className="mb-5">
                    <Radio
                        checked={userName === email}
                        name="email"
                        onClick={() => {
                            setApiError('')
                            if (userName === email) {
                                setEmail('')
                            } else {
                                setEmail(userName)
                            }
                        }}
                    >
                        <span className="fs-3 c-neutral-700 ml-2">{transformEmail(userName)}</span>
                    </Radio>
                </div>
            )
        })
    }

    const sendOtp = async () => {
        setLoading(true)
        const payload = {
            type: 'EMAIL',
            value: email,
            action: 'SIGNUP_MERGE'
        }
        const res = await sendOtpForSignIn(payload)
        const { status, data, error } = res || {}
        if (status === 202) {
            setPageName(USER_PROFILE_PAGE_CONTANTS.VERIFY_EMAIL)
        } else {
            const { response = { data: {} } } = error || {}
            const { data = {} } = response
            const { message } = data
            const err = errorConfig[message] || errorConfig.default
            setApiError(err)
        }
        setLoading(false)
    }

    const noEmailSelectedHandler = async () => {
        setEmail('')
        // const res = await checkForLinkingNudge()
        // const { status, data } = res || {}
        // if (status === 200) {
        //     if (data.action) {
        //         setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
        //     } else {
        setPageName(USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS)
        //     }
        // } else {
        //     const { message } = data
        //     const error = errorConfig[message] || errorConfig.default
        //     setApiError(error)
        // }
    }
    return (
        <div
            className="bg-white br-4 br-4 o-hidden d-flex flex-column"
            style={{
                width: '400px',
                height: '468px'
            }}
        >
            <div className={`${animatedClass} d-flex flex-1 flex-column`}>
                <ModalHeader title={'Verify email address'} toggle={toggle} showCloseButton={showCloseButton} />
                {apiError && (
                    <>
                        <div
                            style={{ marginBottom: '22px' }}
                            className="py-3 px-2 flex flex-middle bg-error-600 c-white fs-2 br-4"
                        >
                            <InfoIcon className="c-white" height={16} width={16} />
                            <span className={errorInfo}>{apiError}</span>
                        </div>
                    </>
                )}
                <OfflineToast page="verify email address" />

                <div className="d-flex flex-column flex-between flex-1">
                    <div>
                        <span className="fs-3 c-neutral-700">Your number</span>
                        <span className="fs-3 c-neutral-700 fw-600">{` ${defaultCountryCode} ${mobileNumber} `}</span>
                        <span className="fs-3 c-neutral-700">
                            has been used for bookings through the following accounts. Select the account that belongs
                            to you.
                        </span>
                        <div
                            className={`mt-6 ${linkedEmails.length > 4 ? 'oy-scroll' : ''}`}
                            style={{ maxHeight: '165px' }}
                        >
                            {renderEmails()}
                        </div>
                    </div>

                    <div className="mb-8">
                        <div className="mb-4">
                            <Button
                                size="md"
                                type="secondary"
                                full
                                busy={loading}
                                disabled={isEmpty(email)}
                                onClick={sendOtp}
                            >
                                <span className="fs-3 fw-550">{'Verify selected email'}</span>
                            </Button>
                        </div>
                        <div className="ta-center fs-3 fw-600 c-blue c-pointer" onClick={noEmailSelectedHandler}>
                            None of these are mine
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmailsLinked
